import { View, TouchableOpacity } from 'react-native'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { SafeAreaView } from 'react-native-safe-area-context'
import { isEmbeddedEnvironment } from 'APP/BrownfieldBridge/utils'

export const Container = styled(SafeAreaView).attrs({
  edges: isEmbeddedEnvironment() ? [] : ['top'],
})`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
  width: 100%;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const TitleContainer = styled(View)`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 85%;
`

export const CloseButton = styled(TouchableOpacity)`
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  padding-left: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  align-self: flex-end;
`

export const SecondaryTextContainer = styled(View)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`

export const Link = styled(Typography)`
  text-decoration-line: underline;
  text-align: center;
  white-space: nowrap;
`
